let router = {
    home: "Home",
    company: {
        title: "Company Mgmt",
        title1: "Company List",
    },
    application: {
        title: "Application Mgmt",
        title1: "Application List",
    },
    device: {
        title: "Device Mgmt",
        title1: "Device List",
    },
    fota: {
        title: "FOTA",
        title1: "Firmware Mgmt",
        title2: "Upgrade Mgmt",
    },
    log: {
        title: "Log Mgmt",
        title1: "Admin Log",
    },
    message: {
        title: "Message Mgmt",
        title1: "Broadcast Record",
    },
    org: {
        title: "Organization",
        title1: "Organization",
    },
    setting: {
        title: "Configuration",
        title1: "Basic Configuration",
    },
    template: {
        title: "Template Mgmt",
        title1: "Voice Template",
        title2: "Print Template"
    },
    user: {
        title: "Administrator",
        title1: "Admin List",
    },
}

export default router
